'use strict';
var React = require('react');
var _ = require('underscore');
var assetsHelper = require('../../helper/assetsHelper');
var projectLoadHelper = require('../../helper/projectLoadHelper');
var HorizontalScrollBar = require('../common/HorizontalScrollBar');
var styleHelper = require('../../helper/styleHelper');

/**
 * 图片流
 */
var CoverFlow = React.createClass({
  render: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    return (<div>
      <div style={{position: 'relative'}}>
        <img width={w} height={h} src={assetsHelper.getComponentAsset('coverFlow')} alt=""/>
        {this.renderCover()}
      </div>
      {
        this.props.horizontalScrollbarShow &&
        <div style={{height: 14, position: 'absolute', width: '100%'}}>
          <HorizontalScrollBar
            value={parseInt(this.props.horizontalScrollbarProgress, 10)}
            left={180 / 985 * w - 3 }
            width={(810 - 180) / 985 * w}
          />
        </div>
      }
    </div>)
  },
  renderCover: function () {
    var imgURL = this.props.URL;
    var measureW = 992;
    var measureH = 404;
    var coverLeft = 310;
    var coverTop = 45;
    var coverRight = 683;
    var coverBottom = 337;
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var ratioW = w / measureW;
    var ratioH = h / measureH;
    var style;
    if (_.isEmpty(imgURL)) {
      return;
    }
    style = {
      position: 'absolute',
      left: coverLeft * ratioW,
      top: coverTop * ratioH,
      width: (coverRight - coverLeft) * ratioW,
      height: (coverBottom - coverTop) * ratioH
    };
    //todo: meng xiao jiang 07-20 这里还未作滤镜处理
    return (
      <img style={style} src={projectLoadHelper.loadImage(imgURL)} alt=""/>
    );
  }
});

module.exports = CoverFlow;



// WEBPACK FOOTER //
// ./src/views/Components/CoverFlow.jsx